import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-avatar-view',
  templateUrl: './user-avatar-view.component.html',
  styleUrls: ['./user-avatar-view.component.css']
})
export class UserAvatarViewComponent implements OnInit {
  @Input() loaded: boolean = false;
  @Input() avatar: string;

  @Input() firstLetter: string;
  @Input() size: string | number = 40;

  @Input() isCircle: boolean = true

  @Input() customClasses: string = '';
  constructor() { }

  ngOnInit() {
  }

}
